import React from 'react';
import './PrivacyPolicy.scss';

export const PrivacyPolicy: React.FC = () => {
  return (
    <div className="privacy-policy">
      <h1>POLÍTICA DE PRIVACIDAD</h1>
      <p><strong>Agosto de 2024</strong></p>

      <p>
        Esta sección incluye toda la información relativa a la gestión de tus datos personales y nuestra política de tratamiento a los mismos.
        Te recomendamos leer minuciosamente estos términos antes de proporcionar tus datos personales en este sitio web.
      </p>

      <p>
        Hemos ajustado este sitio web a las disposiciones de la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía
        de los derechos digitales, así como al Real Decreto 1720/2007, de 21 de diciembre, conocido como el Reglamento de desarrollo de la LOPD.
        También cumplimos con el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 (RGPD),
        y con la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSICE o LSSI).
      </p>

      <p>
        Es importante tener en cuenta que esta Política de Privacidad puede cambiar según las exigencias legislativas o de autorregulación,
        por lo que se aconseja a los usuarios que la revisen periódicamente.
      </p>

      <h2>1. ¿QUIÉN ES EL RESPONSABLE DEL TRATAMIENTO DE LOS DATOS PERSONALES?</h2>
      <p>
        <strong>Razón Social:</strong> Lendit<br />
        <strong>CIF:</strong> B70958756<br />
        <strong>Domicilio social:</strong> Barrio Caceo, nº7, Molledo, Cantabria<br />
        <strong>Teléfono:</strong> 610638148<br />
        <strong>Correo electrónico:</strong> lenditsl@gmail.com<br />
        <strong>Forma jurídica:</strong> S.L.
      </p>

      <h2>2. PRINCIPIOS QUE APLICAREMOS A TU INFORMACIÓN PERSONAL</h2>
      <ul>
        <li><strong>Licitud, lealtad y transparencia:</strong> solo recopilamos tus datos para fines específicos, explícitos y legítimos.</li>
        <li><strong>Minimización de datos:</strong> recogemos únicamente los datos necesarios para los fines previstos.</li>
        <li><strong>Limitación del plazo de conservación:</strong> mantenemos los datos solo durante el tiempo necesario.</li>
        <li><strong>Integridad y confidencialidad:</strong> garantizamos la seguridad y confidencialidad de los datos proporcionados.</li>
      </ul>

      <h2>3. RECOGIDA Y TRATAMIENTO DE LOS DATOS PERSONALES</h2>
      <p>Los tipos de datos que se pueden solicitar y tratar son:</p>
      <ul>
        <li>Nombre y apellidos</li>
        <li>Género (opcional)</li>
        <li>Domicilio</li>
        <li>DNI</li>
        <li>Fecha de nacimiento (para comprobar mayoría de edad)</li>
        <li>Datos de tarjeta para pagos</li>
        <li>Correo electrónico</li>
        <li>Número de teléfono</li>
      </ul>
      <p>Estos datos se tratarán si el usuario se registra.</p>

      <h2>4. LEGITIMACIÓN PARA EL TRATAMIENTO DE LOS DATOS PERSONALES</h2>
      <p>Tus datos personales podrán tratarse si:</p>
      <ul>
        <li>Nos das tu consentimiento explícito.</li>
        <li>Existe un requerimiento legal (por ejemplo, obligaciones fiscales).</li>
        <li>Existe un interés legítimo no perjudicial para tus derechos.</li>
        <li>Es necesario para la ejecución de un contrato o prestación de servicio.</li>
      </ul>

      <h2>5. FINALIDAD DEL TRATAMIENTO DE TUS DATOS PERSONALES</h2>
      <p>Los fines principales del tratamiento son:</p>
      <ul>
        <li>Prestación y ejecución del servicio contratado.</li>
        <li>
          Envío de comunicaciones comerciales por medios electrónicos o físicos relacionadas con productos o servicios
          del RESPONSABLE o de sus socios, sin que los terceros accedan a tus datos.
        </li>
        <li>Atención a consultas, solicitudes o peticiones del usuario.</li>
        <li>Cumplimiento de obligaciones legales y condiciones de uso.</li>
      </ul>

      <h2>6. PLAZO DE CONSERVACIÓN DE TUS DATOS PERSONALES</h2>
      <p>
        Los datos serán conservados mientras sean necesarios para cumplir con los fines indicados o hasta que retires tu
        consentimiento, salvo obligación legal que establezca lo contrario.
      </p>

      <h2>7. DESTINATARIOS</h2>
      <p>
        Los datos no serán cedidos a terceros salvo obligación legal.
        Tienes derecho a:
      </p>
      <ul>
        <li>Solicitar acceso a tus datos</li>
        <li>Solicitar su rectificación o supresión</li>
        <li>Solicitar la limitación u oposición al tratamiento</li>
        <li>Solicitar la portabilidad de los datos</li>
      </ul>
      <p>
        Puedes ejercer estos derechos escribiendo por correo postal a la dirección social o por correo electrónico.
        También puedes reclamar ante la Agencia Española de Protección de Datos.
      </p>

      <h2>8. REVOCABILIDAD DEL CONSENTIMIENTO OTORGADO</h2>
      <p>
        Puedes revocar en cualquier momento tu consentimiento para el tratamiento y la transferencia de tus datos.
        Esta revocación no tendrá efecto retroactivo.
      </p>

      <h2>9. MEDIDAS DE SEGURIDAD</h2>
      <p>
        El RESPONSABLE ha adoptado las medidas técnicas y organizativas apropiadas para garantizar la seguridad,
        integridad y confidencialidad de los datos personales, cumpliendo con el GDPR y la LOPDGDD.
      </p>

      <h2>10. INFORMACIÓN LEGAL</h2>
      <p>
        Esta Política de Privacidad complementa la legislación vigente en materia de protección de datos. Está sujeta a
        revisiones y modificaciones. Notificaremos cualquier cambio y solicitaremos tu aceptación de la nueva versión.
      </p>

      <p>Para más información, puedes contactarnos en: <strong>lenditsl@gmail.com</strong></p>
    </div>
  );
};